import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const DISMISS_KEY = "ap_welcome_dismissed_v1";

export default function WelcomePopup() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) return;
        if (localStorage.getItem(DISMISS_KEY)) return;
        const t = setTimeout(() => setOpen(true), 4500);
        return () => clearTimeout(t);
    }, [user]);

    if (!open) return null;

    const close = () => {
        localStorage.setItem(DISMISS_KEY, "1");
        setOpen(false);
    };

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/subscribe", { email });
            toast.success("WELCOME10 reserved. Sign up to apply at checkout.");
            close();
            navigate(`/register?email=${encodeURIComponent(email)}`);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" data-testid="welcome-popup">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={close} />
            <div className="relative w-full max-w-md bg-[var(--bg-carbon)] border border-[var(--brand)] reveal">
                <button onClick={close} data-testid="welcome-close" className="absolute top-3 right-3 p-2 text-secondary hover:text-brand">
                    <X size={16} />
                </button>
                <div className="p-10 text-center">
                    <Sparkles size={28} className="text-brand mx-auto mb-4" />
                    <div className="data-label text-brand mb-3">NEW MEMBER OFFER</div>
                    <h2 className="font-serif text-5xl text-primary leading-none mb-3">10% OFF</h2>
                    <p className="text-sm text-secondary mb-8">Your first order — applied automatically when you sign up for an Aminoplex research account.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            required
                            data-testid="welcome-email-input"
                            placeholder="researcher@laboratory.com"
                            className="input text-center"
                        />
                        <button type="submit" disabled={loading} data-testid="welcome-submit-btn" className="btn btn-gold w-full">
                            {loading ? "Reserving…" : "Claim 10% Off"}
                        </button>
                    </form>
                    <p className="data-label mt-6 text-[0.6rem]">Code: <span className="text-brand">WELCOME10</span> · One per researcher</p>
                </div>
            </div>
        </div>
    );
}
